import React from 'react';
export default class Footer extends React.Component {
    
    render() {
        let date = new Date();
        return ( <div className="footer mt-5">
            <div className="pull-right">
                
            </div>
            <div>
                <strong>Copyright</strong> Opalina Technologies &copy; {date.getFullYear()}
            </div>
        </div> )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Footer.jsx